export enum EUserTypeFilter {
    All = 'All',
    Admin = 'Administrator',
    Portal = 'Customer',
    Internal = 'Internal'
}

export enum EUserPortalPermissionFilter {
    None = 'None',
    Stock = 'Search and check stock only',
    StockAndPricing = 'Get pricing, search and check stock',
    StockPricingOrdering = 'Place orders, get pricing, search and check stock'
}

export enum EUserStatusFiler {
    All = 'All',
    Active = 'Active',
    Disabled = 'Disabled'
}

export interface IAnyUser {
    id: number;
    username: string;
    email: string;
    emailConfirmed: boolean;
    name: string | null;
    isCustomer: boolean;
    isAdmin: boolean;
    isInternal: boolean;
    typeId: number;
    cardcode: string | null;
    slpcode: number | null;
    portalPermissionId: number;
    isActive: boolean;
    lastLoggedAt: Date;
    updatedAt: Date;
    createdAt: Date;
}

export interface IUserFromApi {
    id: number;
    username: string;
    email: string;
    confirmEmail: 1 | 0;
    name: string | null;
    cardcode: string | null;
    slpcode: number | null;
    typeId: number;
    permissionId: number;
    status: 1 | 0;
    lastLoginAt: string | null;
    updatedAt: string;
    createdAt: string;
}

export interface IUsersListFromApi {
    data: IUserFromApi[];
    limit: number;
    skip: number;
    total: number;
}

export interface ICustomerFromApi {
    cardcode: string;
    cardname: string;
    slpcode: number | null;
    slpname: string | null;
    email: string | null;
    message: string | null;
    contactname: string | null;
    groupnum: number | null;
    terms: string | null;
    balance: number | null;
    whscode: string | null;
    listnum: number | null;
    listnum2: number | null;
    groupcode: number | null;
    custgroup: string | null;
    splgroup: number | null;
}

export interface ICustomersListFromApi {
    data: ICustomerFromApi[];
    limit: number;
    skip: number;
    total: number;
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--0!./app/common/interfaces/users.ts